module.exports = __webpack_public_path__ + "media/images/common/large_off-802fb48fa4bc8dcd5673fa63f159aa27.gif";